<ul *ngIf="toc">
  <li *ngFor="let heading of toc.headings" [ngClass]="'section-depth-'+heading.depth" (click)="itemClicked(toc.documentId, heading.sectionId)">
    <a>{{heading.title}}</a>
  </li>
</ul>
